import { type NumericFormatProps, numericFormatter } from 'react-number-format';

import { CURRENCY, MONETARY_FORMAT_PROPS } from '../../constants/formatter-parameters';
import { EMPTY_SYMBOL } from '../../constants/string-constants';

export const formatToMonetary = (
  value?: null | number,
  props?: NumericFormatProps,
  displayEmpty = true
) => {
  const defaultProps = {
    ...MONETARY_FORMAT_PROPS,
    ...props,
  };

  if (value || (value === 0 && !displayEmpty)) {
    return numericFormatter(
      `${value}`,
      value < 0 ? { ...defaultProps, prefix: `${CURRENCY} -` } : defaultProps
    );
  }

  return EMPTY_SYMBOL;
};
